<template>
    <cv-modal :visible.sync="visible" @hide="clear" @check="check" c="modal default medium" title="增加产品">
        <cv-form label="产品名称" :labelWidth="4" c="form default medium distant-y">
            <cv-input v-model.trim="product.name" c="input default small"></cv-input>
        </cv-form>
        <cv-form label="满仓金额" :labelWidth="4" c="form default medium distant-y">
            <cv-input v-model.number="product.fullAmount" c="input default small"></cv-input>
        </cv-form>
        <cv-form label="初始金额" :labelWidth="4" c="form default medium distant-y">
            <cv-input v-model.number="product.amount" c="input default small"></cv-input>
        </cv-form>
        <cv-form label="风险等级" :labelWidth="4" c="form default medium distant-y">
            <cv-select v-model="product.risk" :options="enums.productRisks" c="select default small"></cv-select>
        </cv-form>
        <cv-form label="关联基金" :labelWidth="4" c="form default medium distant-y">
            <cv-select v-model="product.fund.id" @search="searchFund" :options="selectFundData" searchable c="select default small"></cv-select>
        </cv-form>
        <cv-form label="关联指数" :labelWidth="4" c="form default medium distant-y">
            <cv-select v-model="product.index.id" @search="searchIndex" :options="selectIndexData" searchable c="select default small"></cv-select>
        </cv-form>
    </cv-modal>
</template>

<script>
    export default {
        name: "ModalProductAdd",
        data() {
            return {
                visible: false,
                product: {
                    name: null,
                    fullAmount: null,
                    amount: null,
                    risk: null,
                    index: {
                        id: null
                    },
                    fund: {
                        id: null
                    }
                },
                select: {
                    index: {
                        keyword: null,
                        data: []
                    },
                    fund: {
                        keyword: null,
                        data: []
                    }
                },
                enums: {
                    productRisks: {
                        HIGH: "高风险",
                        MIDDLE: "中风险",
                        LOW: "低风险"
                    }
                }
            }
        },
        computed: {
            selectFundData() {
                let selectFundData = [];
                if (!this.select.fund.data) {
                    return selectFundData;
                }
                for (let i=0; i<this.select.fund.data.length; i++) {
                    let fund = this.select.fund.data[i];
                    selectFundData.push({
                        id: fund.id,
                        name: fund.name + " (" + fund.code + ")",
                        origin: selectFundData
                    });
                }
                return selectFundData;
            },
            selectIndexData() {
                let selectIndexData = [];
                if (!this.select.index.data) {
                    return selectIndexData;
                }
                for (let i=0; i<this.select.index.data.length; i++) {
                    let index = this.select.index.data[i];
                    selectIndexData.push({
                        id: index.id,
                        name: index.name + " (" + index.code + ")",
                        origin: index
                    });
                }
                return selectIndexData;
            }
        },
        methods: {
            async searchFund(keyword) {
                this.select.fund.keyword = keyword;
                this.select.fund.data = await this.$remotes.server.financing.index.search(keyword, "FUND");
            },
            async searchIndex(keyword) {
                this.select.index.keyword = keyword;
                this.select.index.data = await this.$remotes.server.financing.index.search(keyword, "INDEX");
            },
            async addProduct() {
                return await this.$remotes.server.financing.product.add({
                    name: this.product.name,
                    fullAmount: this.product.fullAmount * 100,
                    amount: this.product.amount * 100,
                    risk: this.product.risk,
                    index: {
                        id: this.product.index.id
                    },
                    fund: {
                        id: this.product.fund.id
                    }
                });
            },
            async check() {
                let success = await this.addProduct();
                if (success) {
                    this.hide()
                    this.$emit("add");
                }
            },
            show() {
                this.visible = true;
            },
            hide() {
                this.visible = false;
                this.clear();
            },
            clear() {
                this.product.name = null;
                this.product.fullAmount = null;
                this.product.risk = null;
                this.product.index.id = null;
                this.product.fund.id = null;
                this.select.index.keyword = null;
                this.select.index.data = [];
                this.select.fund.keyword = null;
                this.select.fund.data = [];
            }
        },
    }
</script>

<style>
</style>
